import { combineReducers } from "redux";

import auth from "./auth";
import user from "./user";
import score from "./score";
import template from "./template";
import storeBelong from "./storeBelong";
import country from "./country";
import packageList from "./packageList";
import order from "./order";
import riskModel from "./riskModel";
import payouts from "./payouts";

export default combineReducers({
  auth,
  user,
  score,
  template,
  storeBelong,
  country,
  packageList,
  order,
  riskModel,
  payouts,
});
